import { useMemo, useState } from 'react'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import AddUserForm from '../admin/AddUserForm'
import { Box, Button, Grid2 } from '@mui/material'
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox'
import { useDialog } from '../../shared/hook/useDialog'
import { useMarketingManagerList, useUserUnderManagerList } from '../../assets/api/useMarketingManager'
import useAuthStore from '../../store/useAuthStore'
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { useMutation } from '@tanstack/react-query'
import { useToaster } from '../../shared/utils/ToasterProvider'
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField'
import CustomDivider from '../../shared/utils/CustomDivider'
import MarketingExecutiveTable from './MarketingExecutiveTable'
import { Grid_Gap } from '../../shared/constants'
import { useZoneOptions } from '../admin/option/ZoneOption'
import api from '../../assets/nodeApi/axiosInstance'
import UtItem from '../../shared/utils/UtList'

const AddMaketingExecutive = () => {
    const [selectedRole, setSelectedRole] = useState({})
    const [selectedApart, setSelectedApart] = useState([])
    const handleRemove = (id) => {
        setSelectedApart(prev => prev.filter(apartment => apartment.id !== id));
    };
    const { open, handleClickOpen, handleClose } = useDialog();
    const { open: openExecutive, handleClickOpen: handleClickOpenExecutive, handleClose: handleCloseExecutive } = useDialog();
    const { token, user } = useAuthStore()
    const { showToaster } = useToaster();
    const { data: userList, isLoading } = useUserUnderManagerList({ main_user_id: user?.id })
    const { data: allUserList, isLoading: allUserListLoading } = useMarketingManagerList({ role: user?.role === 'Marketing_Manager' ? 'Marketing Manager' : user?.role })
    console.log(user)
    const [userId, setUserId] = useState("")

    const UserListOption =
        userList
            ?.filter((item) => item?.role === selectedRole?.value)
            ?.map((item) => ({
                id: item?.id,
                value: item?.firstname,
                label: item?.firstname,
                ...item,
            })) || [];

    const roleOption = [
        {
            id: 1,
            label: "Zonal Coordinator",
            value: "Zonal Coordinator"

        },
        {
            id: 2,
            label: "Marketing Executive",
            value: "Marketing Executive"

        }
    ]

    const ReportingToOption = allUserList?.map((item) => ({
        id: item?.id,
        value: item?.firstname,
        label: item?.firstname
    })) || [];

    console.log(ReportingToOption, "ReportingToOption");


    const { AddedZoneOptions } = useZoneOptions()

    const updateReportingTo = useMutation({
        mutationFn: (formData) => api.put(`users/update-zone-reporting/${userId}`, formData,

            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        ),
    });

    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        const obj = {
            zone_id: selectedApart?.map((item) => item?.id),
            reporting_to: values.reporting_to,
        }
        updateReportingTo.mutate(obj, {
            onSuccess: (response) => {
                if (response?.data?.message) {
                    showToaster('Success', response?.data?.message, 'success');
                }
            },
            onError: (error) => {
                showToaster('Error', error?.message || "Something went wrong1", 'error');
            },
            onSettled: () => {
                setSubmitting(false);
            },

        });
        handleClose()
    }
    return (
        <>
            <NormalContainerWithHeader headerText={"Create Marketing Executive"}>


                <Grid2 container spacing={Grid_Gap}>
                    <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>

                        <Button variant='contained' onClick={handleClickOpenExecutive} fullWidth>Add Marketing Executive</Button>
                    </Grid2>
                    <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                        <Button variant='contained' onClick={handleClickOpen} fullWidth>Update Reporting User</Button>
                    </Grid2>


                </Grid2>



            </NormalContainerWithHeader>

            <MainDialogBox open={open} handleClose={handleClose} width={"60%"}>

                <Formik initialValues={{
                    zone_id: null,
                    reporting_to: null,
                    user_id: null
                }}
                    validationSchema={Yup.object().shape({
                        // zone_id: Yup.string().required("Zone is required"),
                        reporting_to: Yup.string().required("reporting to person is required"),
                        user_id: Yup.string().required("User Id is required"),
                    })}
                    onSubmit={handleSubmit}>
                    {({ setFieldValue }) => (
                        <Form>
                            <Grid2 container spacing={"30px"}>

                                <Grid2 children size={{ xs: 12, md: 6 }}>
                                    <Field
                                        name="role"
                                        component={IdAutoCompleteField}
                                        options={roleOption}
                                        label="Role"
                                        isRequired={false}
                                        isLoading={isLoading}
                                        onValueChange={(newValue) => {
                                            setSelectedRole(newValue)
                                        }}
                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 12, md: 6 }}>
                                    <Field
                                        name="user_id"
                                        component={IdAutoCompleteField}
                                        options={UserListOption}
                                        label="User List"
                                        isRequired={true}
                                        isLoading={isLoading}
                                        onValueChange={(newValue) => {
                                            setSelectedApart([])

                                            setUserId(newValue?.id);

                                            setSelectedApart((prev) => {
                                                const formattedZones =
                                                    newValue?.zones?.map((zone) => ({
                                                        id: String(zone.id),
                                                        label: zone.zone_name,
                                                        value: zone.zone_name,
                                                    })) || [];

                                                const merged = [...prev];

                                                formattedZones.forEach((zone) => {
                                                    if (!merged.find((item) => item.id === zone.id)) {
                                                        merged.push(zone);
                                                    }
                                                });

                                                return merged;
                                            });
                                        }}
                                    />
                                </Grid2>
                                <Grid2 size={12}>
                                    <Box sx={{ display: "flex", gap: 1, my: 2 }}>

                                        {selectedApart?.map((item, index) => (
                                            <UtItem key={index} text={item?.label} onRemove={() => { handleRemove(item?.id) }} />

                                        ))}
                                    </Box>
                                </Grid2>
                                <Grid2 children size={{ xs: 12, md: 6 }}>
                                    <Field
                                        name="zone_id"
                                        component={IdAutoCompleteField}
                                        options={AddedZoneOptions.options}
                                        label="Select Zone"
                                        isRequired={true}
                                        isLoading={AddedZoneOptions.isLoading}
                                        onValueChange={(newValue) => {

                                            setSelectedApart((prev) => {
                                                const exists = prev.find((item) => item.id === newValue.id);
                                                return exists ? prev : [...prev, newValue];
                                            });
                                            setFieldValue("zone_id", "")
                                        }}
                                    />
                                </Grid2>

                                <Grid2 children size={{ xs: 12, md: 6 }}>
                                    <Field
                                        name="reporting_to"
                                        component={IdAutoCompleteField}
                                        options={ReportingToOption}
                                        label="Reporting To"
                                        isRequired={true}
                                        isLoading={allUserListLoading}
                                    />
                                </Grid2>


                                <Grid2 children size={12}>
                                    <Button variant='contained' fullWidth type="submit">Update</Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>

            </MainDialogBox >

            <CustomDivider />


            <MarketingExecutiveTable />


            <MainDialogBox open={openExecutive} handleClose={handleCloseExecutive} width={"60%"}>
                <AddUserForm
                    onClose={handleCloseExecutive}
                    RoleOption={[{
                        label: 'Marketing Executive',
                        value: "Marketing Executive"
                    },]}
                />
            </MainDialogBox >
        </>

    )
}

export default AddMaketingExecutive